import React, { FC, lazy } from 'react';
import { modalRoutes } from 'constants/routes';
import UserPermissionGate from 'components/UserPermissionGate';
import { UserPermission } from 'constants/userPermission';
import ModalRoute from 'context/ModalRouter';

type Props = {};

const DeleteReport = lazy(
  () => import('app/modules/reports/modules/deleteReportModal'),
);
const ShareReport = lazy(
  () => import('app/modules/reports/modules/shareReportModal'),
);
const DuplicateReport = lazy(
  () => import('app/modules/reports/modules/duplicateReportModal'),
);

const ViewReport = lazy(
  () => import('app/modules/reports/modules/viewReportModal'),
);

const AutomateReport = lazy(
  () => import('app/modules/reports/modules/automateReportModal'),
);

const ReportsModals: FC<Props> = (props) => {
  return (
    <>
      <UserPermissionGate scopes={[UserPermission.REPORT_DELETE]}>
        <ModalRoute path={modalRoutes.DELETE_REPORT} component={DeleteReport} />
      </UserPermissionGate>
      <UserPermissionGate scopes={[UserPermission.REPORT_SHARE_PREVIEW]}>
        <ModalRoute path={modalRoutes.SHARE_REPORT} component={ShareReport} />
      </UserPermissionGate>
      <UserPermissionGate scopes={[UserPermission.REPORT_CREATE]}>
        <ModalRoute
          path={modalRoutes.DUPLICATE_REPORT}
          component={DuplicateReport}
        />
      </UserPermissionGate>
      <ModalRoute path={modalRoutes.VIEW_REPORT} component={ViewReport} />
      <UserPermissionGate scopes={[UserPermission.REPORT_CREATE]}>
        <ModalRoute
          path={modalRoutes.AUTOMATE_REPORT}
          component={AutomateReport}
        />
      </UserPermissionGate>
    </>
  );
};

export default ReportsModals;
